import { matchQuery } from '@lhb/func';

export default {
  meta: {
    title: (to: { search?: string }) => matchQuery(to.search || '', 'id') ? '编辑客户调研' : '新增客户调研',
    url: '/abside/customeredit',
    urlName: 'ab侧-客户编辑',
    logincallback: '/abside',
  }
};
